import React from "react";

const ClosingStatement = () => {
  const [textArray, setTextArray] = React.useState([]);

  const text = `Backed by over 35 years of home-grown, hands-on design, and innovative audio engineering experience, Anthem products provide an unprecedented level of reliability and functionality, delivering one of the industry's highest performance/price ratios. This is just one reason why Anthem electronics are the choice of knowledgeable audiophiles, professional musicians and engineers the world over.`;

  React.useEffect(() => {
    function handleScroll() {
      const elementBoundaries = document
        .querySelector(".closing p")
        .getBoundingClientRect();

      let percentage = 0;

      if (elementBoundaries.top - 500 < 0) {
        percentage = Math.abs(
          ((elementBoundaries.top - 500) / elementBoundaries.height) * 100
        );

        percentage = percentage > 100 ? 100 : percentage;
      }

      const textArray = text.split("");

      const numOfWhiteChars = (textArray.length * percentage) / 100;

      const newTextArray = textArray.map((c, i) => (
        <span className={i < numOfWhiteChars ? "text-white" : null}>{c}</span>
      ));

      setTextArray(newTextArray);
    }

    document.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section
      className="z-50 relative h-full"
      id="intoduction"
      style={{
        backgroundImage:
          "url('https://cdn.pmlsound.com/anthem/avm90/images/avm-highlight-text-bg.jpeg')",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute bg-black/80 h-full w-full"></div>
      <div className=" py-44 px-5 md:py-44 z-50 relative">
        <div className="max-w-6xl mx-auto  closing ">
          <p className="leading-relaxed text-2xl md:text-3xl lg:text-4xl font-light lg:text-center text-center z-50 text-gray-500 ">
            {textArray.length ? textArray : text}
          </p>
        </div>
      </div>
    </section>
  );
};

export default ClosingStatement;
